<template>
  <label class="i-switch">
    <input ref="checkbox" type="checkbox" v-model="dataValue" @input="handleInput($event)" @change="handleChange($event)" :checked="value">
    <span class="slider"></span>
  </label>
</template>

<script>
export default {
  name: 'switcher',
  props: {
    label: {
      type: [String, Number, Boolean],
      default: null
    },
    value: {
      type: [Boolean, Number, String],
      default: false
    },
    color: {
      type: String,
      default: 'primary'
    }
  },
  data () {
    return {
      dataValue: this.value
    }
  },
  mounted () {
    this.$refs.checkbox.checked = this.value
  },
  updated () {
    this.$refs.checkbox.checked = this.value
  },
  methods: {
    handleInput (e) {
      this.$emit('input', e.target.checked)
    },
    handleChange (e) {
      this.$emit('change', e.target.checked)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ui/switch.vue